import Image from 'next/image';
import { api } from "../../services/api/interceptor.client";
import { LoggedResponse } from "@/src/types/request-response.types";
import { useEffect, useRef, useState } from 'react';

export default function Corps() {
  const [response, setResponse] =
    useState<LoggedResponse>({
      status: true,
      data: {
        body: [],
        config:
        {
          head: [],
          primaryKey: [],
          pKIdx: []
        }
      }
    });  
  
  const [isList,setIsList]=useState<boolean>(true);
  
  const loaded = useRef(false);

  const onClick = (e: React.MouseEvent<HTMLElement>) => {
    const card = (e.target as HTMLElement).closest('.card');
    if (card) {
      const id: number = Number((card as HTMLElement).dataset.id ?? 0) + 1;
      api.post("/corp/use/" + id).then(() => setIsList(false));
    }
  };
  
  useEffect(() => {
    if (loaded.current) { loaded.current = false; return; }
    loaded.current = true;

    api.get("/corp/list")
      .then(res => {
        setIsList(res.data.data?.body !== undefined);
        if (res.data.data?.body !== undefined) setResponse(res.data);
      });
  },[]);

  const corps = (response?.data?.body ?? []) as string[][];

  const list = (
    <div className="card-group mt-5" onClick = { onClick } >
      {corps!.map((corp, idx) => {
        return (
          <div key={idx} data-id={idx} className="card m-2 w-25 cursor-pointer">
            <Image src="/img.jpg" className="card-img-top" width="200" height="130" alt="..." />
            <div className="card-body">
              <h5 className="card-title">{corp[1]}</h5>
              <p className="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
            </div>
            <div className="card-footer">
              <small className="text-body-secondary">Last updated 3 mins ago</small>
            </div>
          </div>
        )
      })}
    </div>
  );

  return isList?list:(<></>);
}
